import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnParkeerplaats = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M29 7H11v26h18z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M18 13h2c2.76 0 5 2.24 5 5s-2.24 5-5 5h-2v5h-3V13zm0 3v4h2c1.1 0 2-.9 2-2s-.9-2-2-2z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M31 32H21v-1h9V18h1zM14 10h-1V5h4v1h-3z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnParkeerplaats);

export default ForwardRef;
